import React from "react";
import s from "./MctacStructure.module.scss";
import ScaledDiagram from "../ScaledDiagram/ScaledDiagram";

// Organisational structure of MCTAC (redrawn from /mctac.png)
// Alphabetical; listed top-to-bottom in two columns
const representatives = [
  { country: "Azerbaijan", code: "MCT_AZ", flag: "/images/azerbaijan.png" },
  { country: "Georgia", code: "MCT_GE", flag: "/images/georgia.png" },
  { country: "Kazakhstan", code: "MCT_KZ", flag: "/images/kazakhstan.png" },
  { country: "Kyrgyzstan", code: "MCT_KG", flag: "/images/kyrgyzstan.png" },
  { country: "Moldova", code: "MCT_MD", flag: "/images/moldova.png" },
  { country: "Tajikistan", code: "MCT_TJ", flag: "/images/tajikistan.png" },
  { country: "Türkiye", code: "MCT_TR", flag: "/images/turkey.png" },
  { country: "Turkmenistan", code: "MCT_TM", flag: "/images/turkmenistan.png" },
  { country: "Ukraine", code: "MCT_UA", flag: "/images/ukraine.png" },
  { country: "Uzbekistan", code: "MCT_UZ", flag: "/images/uzbekistan.png" },
];

const teams = [
  "Team of Customs Clearance",
  "Team of Customs Expertise",
  "Team of Customs Brokerage",
  "Team of Experts on the Protection of Carriers' and Entrepreneurs' Rights",
];

const MctacStructure = () => (
  <figure className={s.chart} aria-label="MCTAC organisational structure">
    <ScaledDiagram designWidth={900}>
      <div className={s.grid}>
        <div className={`${s.node} ${s.founder}`}>
          <span className={s.caption}>Supreme body</span>
          National Customs Association of the Republic of Moldova
        </div>

        <div className={`${s.node} ${s.board} ${s.from_top}`}>
          <span className={s.caption}>Strategic decisions</span>
          The Board of the Committee
        </div>
        <div className={s.link_right} aria-hidden="true"></div>
        <div className={`${s.node} ${s.main} ${s.from_top}`}>
          Middle Corridor Transit Advisory Committee
        </div>

        <div className={`${s.node} ${s.partners} ${s.from_top}`}>
          Regional Representatives
          <span className={s.sub}>(Partners)</span>
        </div>
        <div className={s.link_side} aria-hidden="true"></div>
        <ul className={s.countries}>
          {representatives.map((r) => (
            <li key={r.code}>
              <img src={r.flag} alt="" />
              <span className={s.country}>{r.country}</span>
              <span className={s.code}>{r.code}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className={s.teams}>
        {teams.map((t) => (
          <div className={`${s.node} ${s.team}`} key={t}>
            {t}
          </div>
        ))}
      </div>
    </ScaledDiagram>
  </figure>
);

export default MctacStructure;
